import React from 'react';

const Whatsapp = () => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '15px',
        right: '15px',
        zIndex: 1000,
      }}
    >
      <a
        href="https://wa.me/+919309534220" // Replace with your WhatsApp link
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          backgroundColor: '#25D366',
          borderRadius: '50%',
          width: '55px',
          height: '55px',
          textAlign: 'center',
          lineHeight: '50px',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          animation: 'pop 1.5s ease-in-out infinite', // Add animation here
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // Replace with your PNG icon link
          alt="Chat on WhatsApp"
          style={{
            width: '40px',
            height: '40px',
          }}
        />
      </a>
      <style>
        {`
          @keyframes pop {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Whatsapp;